import { getMobilityReport } from "./../api/mobility";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { GetReportParams, MobilityReportByUser } from "../types/types";

interface ReportParams extends GetReportParams {
  fetch: boolean;
  options?: UseQueryOptions<
    MobilityReportByUser[],
    unknown,
    MobilityReportByUser[],
    string[]
  >;
}

const useGetMobilityReport = ({
  startDate,
  endDate,
  mobility_seq,
  open,
  page,
  limit,
}: ReportParams) => {
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: [
      "MobilityReport",
      `startDate-${startDate}`,
      `endDate-${endDate}`,
      `mobility_seq-${String(mobility_seq)}`,
      `limit${limit}`,
      `page${page}`,
    ],
    queryFn: () =>
      getMobilityReport({ startDate, endDate, mobility_seq, page, limit }),

    retry: false,
    enabled: !!open,
    refetchOnWindowFocus: false, // 포커스 이동해도 리패치 안함
  });

  return { data, isLoading, isSuccess };
};

export default useGetMobilityReport;
